import SvgColor from "../../../components/svg-color";

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

const navConfigMen = [
  {
    title: "Matches",
    path: "/dashboard/matches?type=men",
    icon: icon("rewind-right-outline"),
  },
  {
    title: "Teams",
    path: "/dashboard/teams?type=men",
    icon: icon("ic_analytics"),
  },
  {
    title: "Rounds",
    path: "/dashboard/rounds?type=men",
    icon: icon("ic_analytics"),
  },
  {
    title: "Conferences",
    path: "/dashboard/conferences?type=men",
    icon: icon("ic_analytics"),
  },
  {
    title: "Bracket Setting",
    path: "/dashboard/bracket-setting?type=men",
    icon: icon("ic_analytics"),
  },
  {
    title: "Leaderboard",
    path: "/dashboard/leaderboard?type=men",
    icon: icon("ic_analytics"),
  }
];

const navConfigWomen = [
  {
    title: "Matches",
    path: "/dashboard/matches?type=women",
    icon: icon("rewind-right-outline"),
  },
  {
    title: "Teams",
    path: "/dashboard/teams?type=women",
    icon: icon("ic_analytics"),
  },
  {
    title: "Rounds",
    path: "/dashboard/rounds?type=women",
    icon: icon("ic_analytics"),
  },
  {
    title: "Conferences",
    path: "/dashboard/conferences?type=women",
    icon: icon("ic_analytics"),
  },
  {
    title: "Bracket Setting",
    path: "/dashboard/bracket-setting?type=women",
    icon: icon("ic_analytics"),
  },
  {
    title: "Leaderboard",
    path: "/dashboard/leaderboard?type=women",
    icon: icon("ic_analytics"),
  }
];

const navConfig = [
  {
    title: "Pages",
    path: "/dashboard/pages?type=all",
    icon: icon("rewind-right-outline"),
  }
];

const main = {
  men: {
    title: "Men's Basketball",
    list: navConfigMen
  },
  women: {
    title: "Women's Basketball",
    list: navConfigWomen
  },
  main: {
    list: navConfig
  }
}

export default main;
